import './Equipments.css';const equipments = "_equipments_1uht9_1";
const styles = {
  equipments
};
export {
  styles as default,
  equipments
};
